module.exports = __webpack_public_path__ + "static/media/transformers.78bd855d.jpg";